import React from 'react';
import { ArrowLeft, Eye } from 'lucide-react';
import { OutfitVirtualTryOn } from './outfit/VirtualTryOn';

const OutfitDemoPage = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-slate-900 text-slate-200">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-slate-900/80 backdrop-blur-md border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="font-medium">Back to VisionLive</span>
          </button>
          
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-violet-500 to-indigo-600 rounded-lg flex items-center justify-center shadow-lg shadow-violet-500/20">
              <Eye className="w-5 h-5 text-white" />
            </div>
            <div className="flex flex-col">
              <span className="font-bold text-white leading-tight">VisionLive</span>
              <span className="text-xs text-violet-400 -mt-0.5">Outfit</span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <span className="px-3 py-1 text-xs font-bold uppercase tracking-wider bg-violet-500/20 text-violet-400 rounded-full border border-violet-500/30">
              Preview
            </span>
          </div>
        </div>
      </header>

      {/* Demo Content */}
      <main className="pt-24 px-4 pb-8">
        <OutfitVirtualTryOn />
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-800 py-8 text-center text-slate-600 text-sm">
        <p>Powered by Google Gemini 2.5 & Veo • VisionLive Outfit</p>
      </footer>
    </div>
  );
};

export default OutfitDemoPage;

